import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import Form from '../../atoms/Form/Form';

const ContributeForm = ({ handleSubmit, children, onKeyDown }) => (
  <Form onSubmit={handleSubmit} onKeyDown={onKeyDown}>
    {children}
  </Form>
);

ContributeForm.propTypes = {
  handleSubmit: PropTypes.func,
  children: PropTypes.node,
  onKeyDown: PropTypes.func,
};

const WrappedContributeForm = reduxForm({
  form: 'contribute',
})(ContributeForm);

WrappedContributeForm.displayName = 'ContributeForm';

export default WrappedContributeForm;
